import ApexCharts from 'apexcharts';

export function initWeatherChart() {
    console.log('Wetterdiagramm wird initialisiert...');

    const weatherDataElement = document.getElementById('weather-data');
    const chartElement = document.querySelector('#weatherChart');

    if (!weatherDataElement || !chartElement) {
        return;
    }

    const weatherData = JSON.parse(weatherDataElement.textContent);

    if (weatherData.length === 0) {
        chartElement.innerHTML = '<p>Keine Wetterdaten vorhanden.</p>';
        return;
    }

    const latest = weatherData[weatherData.length - 1];
    updateCurrentWeather(latest);

    const chartInfo = {
        temperature: {
            name: 'Temperatur',
            unit: ' °C',
            axis: 'Temperatur (°C)',
            decimals: 1,
            curve: 'smooth'
        },
        humidity: {
            name: 'Luftfeuchtigkeit',
            unit: ' %',
            axis: 'Luftfeuchtigkeit (%)',
            decimals: 0,
            curve: 'smooth'
        },
        pressure: {
            name: 'Luftdruck',
            unit: ' hPa',
            axis: 'Luftdruck (hPa)',
            decimals: 0,
            curve: 'smooth'
        },
        pressure_at_sea_level: {
            name: 'Luftdruck Meereshöhe',
            unit: ' hPa',
            axis: 'Luftdruck auf Meereshöhe (hPa)',
            decimals: 0,
            curve: 'smooth'
        },
        light: {
            name: 'Helligkeit',
            unit: ' lx',
            axis: 'Helligkeit (lx)',
            decimals: 0,
            curve: 'smooth'
        },
        rain: {
            name: 'Regenindex',
            unit: '',
            axis: 'Regenindex',
            decimals: 0,
            curve: 'stepline'
        },
        uv_light: {
            name: 'UV-Index',
            unit: '',
            axis: 'UV-Index',
            decimals: 0,
            curve: 'stepline'
        },
        gas: {
            name: 'AQI-Index',
            unit: '',
            axis: 'Luftqualität / AQI-Index',
            decimals: 0,
            curve: 'smooth'
        }
    };

    const chartData = {
        temperature: createSeriesData(weatherData, 'temperature'),
        humidity: createSeriesData(weatherData, 'humidity'),
        pressure: createSeriesData(weatherData, 'pressure'),
        pressure_at_sea_level: createSeriesData(weatherData, 'pressure_at_sea_level'),
        light: createSeriesData(weatherData, 'light'),
        rain: createRainIndexData(weatherData),
        uv_light: createUvIndexData(weatherData),
        gas: createSeriesData(weatherData, 'gas')
    };

    const initialKey = 'temperature';

    const options = {
        chart: {
            type: 'area',
            height: 350,
            width: '100%',
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            },
            animations: {
                enabled: false
            },
        },
        series: [{
            name: chartInfo[initialKey].name,
            data: chartData[initialKey]
        }],
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: chartInfo[initialKey].curve,
            width: 3
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.35,
                opacityTo: 0.05,
                stops: [0, 90, 100]
            }
        },
        colors: ['#006989'],
        xaxis: {
            type: 'datetime',
            title: {
                text: 'Uhrzeit'
            },
            labels: {
                datetimeUTC: false,
                formatter: function (value) {
                    return formatTime(value);
                }
            }
        },
        yaxis: createYAxisOptions(initialKey, chartInfo),
        tooltip: createTooltipOptions(initialKey, chartInfo)
    };

    const chart = new ApexCharts(chartElement, options);
    chart.render();

    initWeatherButtons(chart, chartData, chartInfo);
}


function createSeriesData(weatherData, key) {
    const rawData = weatherData.map(data => ({
        x: new Date(data.measured_at).getTime(),
        y: data[key]
    }));

    return smoothSeriesData(rawData, 0);
}


function createRainIndexData(weatherData) {
    return weatherData.map(data => ({
        x: new Date(data.measured_at).getTime(),
        y: rainIndexToNumber(data.rain_index)
    }));
}


function createUvIndexData(weatherData) {
    return weatherData.map(data => ({
        x: new Date(data.measured_at).getTime(),
        y: uvIndexToNumber(data.uv_index)
    }));
}


function rainIndexToNumber(value) {
    if (value === 'Trocken') {
        return 0;
    }

    if (value === 'Nieselregen') {
        return 1;
    }

    if (value === 'Regen') {
        return 2;
    }

    return null;
}


function rainNumberToIndex(value) {
    const roundedValue = Math.round(Number(value));

    if (roundedValue === 0) {
        return 'Trocken';
    }

    if (roundedValue === 1) {
        return 'Nieselregen';
    }

    if (roundedValue === 2) {
        return 'Regen';
    }

    return '–';
}


function uvIndexToNumber(value) {
    if (value === '< 3') {
        return 0;
    }

    if (value === '3-5') {
        return 1;
    }

    if (value === '6-7') {
        return 2;
    }

    if (value === '8-10') {
        return 3;
    }

    if (value === '≥ 11') {
        return 4;
    }

    return null;
}


function uvNumberToIndex(value) {
    const roundedValue = Math.round(Number(value));

    if (roundedValue === 0) {
        return 'Niedrig';
    }

    if (roundedValue === 1) {
        return 'Mäßig';
    }

    if (roundedValue === 2) {
        return 'Hoch';
    }

    if (roundedValue === 3) {
        return 'Sehr hoch';
    }

    if (roundedValue === 4) {
        return 'Extrem';
    }

    return '–';
}


function uvIndexToLabel(value) {
    if (value === '< 3') {
        return 'Niedrig';
    }

    if (value === '3-5') {
        return 'Mäßig';
    }

    if (value === '6-7') {
        return 'Hoch';
    }

    if (value === '8-10') {
        return 'Sehr hoch';
    }

    if (value === '≥ 11') {
        return 'Extrem';
    }

    return value || '–';
}


function createYAxisOptions(key, chartInfo) {
    if (key === 'rain') {
        return {
            min: 0,
            max: 2,
            tickAmount: 2,
            title: {
                text: chartInfo[key].axis
            },
            labels: {
                formatter: function (value) {
                    return rainNumberToIndex(value);
                }
            }
        };
    }

    if (key === 'uv_light') {
        return {
            min: 0,
            max: 4,
            tickAmount: 4,
            title: {
                text: chartInfo[key].axis
            },
            labels: {
                formatter: function (value) {
                    return uvNumberToIndex(value);
                }
            }
        };
    }

    return {
        title: {
            text: chartInfo[key].axis
        },
        labels: {
            formatter: function (value) {
                return formatValue(value, chartInfo[key].decimals);
            }
        }
    };
}


function createTooltipOptions(key, chartInfo) {
    return {
        x: {
            formatter: function (value) {
                return formatDateTime(value);
            }
        },
        y: {
            formatter: function (value) {
                if (key === 'rain') {
                    return rainNumberToIndex(value);
                }

                if (key === 'uv_light') {
                    return uvNumberToIndex(value);
                }

                return formatValue(value, chartInfo[key].decimals) + chartInfo[key].unit;
            }
        }
    };
}


function initWeatherButtons(chart, chartData, chartInfo) {
    const buttons = document.querySelectorAll('.weather-btn');
    const cards = document.querySelectorAll('.weather-card');

    function activateSeries(key) {
        if (!chartData[key] || !chartInfo[key]) {
            return;
        }

        buttons.forEach(btn =>
            btn.classList.toggle('active', btn.dataset.series === key)
        );

        cards.forEach(card =>
            card.classList.toggle('active', card.dataset.series === key)
        );

        chart.updateOptions({
            stroke: {
                curve: chartInfo[key].curve,
                width: 3
            },
            yaxis: createYAxisOptions(key, chartInfo),
            tooltip: createTooltipOptions(key, chartInfo)
        });

        chart.updateSeries([{
            name: chartInfo[key].name,
            data: chartData[key]
        }]);
    }

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            activateSeries(button.dataset.series);
        });
    });

    cards.forEach(card => {
        card.addEventListener('click', () => {
            activateSeries(card.dataset.series);
        });
    });
}


function updateCurrentWeather(latest) {
    setText(
        'currentTemperature',
        latest.temperature,
        value => `${value.toFixed(1)} °C`
    );

    setText(
        'currentHumidity',
        latest.humidity,
        value => `${value.toFixed(0)} %`
    );

    setText(
        'currentPressure',
        latest.pressure,
        value => `${value.toFixed(0)} hPa`
    );

    setText(
        'currentPressureAtSeaLevel',
        latest.pressure_at_sea_level,
        value => `${value.toFixed(0)} hPa`
    );

    setText(
        'currentLight',
        latest.light,
        value => `${value.toFixed(0)} lx`
    );

    setPlainText('currentRain', latest.rain_index);

    setPlainText('currentUvLight', uvIndexToLabel(latest.uv_index));

    setText(
        'currentGas',
        latest.gas,
        value => `${value.toFixed(0)}`
    );

    setPlainText('currentRainIndex', latest.rain_index);
    setPlainText('currentUvIndex', uvIndexToLabel(latest.uv_index));

    const measuredAtElement = document.getElementById('currentMeasuredAt');

    if (measuredAtElement && latest.measured_at) {
        measuredAtElement.textContent = formatFullDateTime(latest.measured_at);
    }
}


function setText(elementId, value, formatter) {
    const element = document.getElementById(elementId);

    if (!element) {
        return;
    }

    if (value === null || value === undefined) {
        element.textContent = '–';
        return;
    }

    element.textContent = formatter(Number(value));
}


function setPlainText(elementId, value) {
    const element = document.getElementById(elementId);

    if (!element) {
        return;
    }

    if (value === null || value === undefined || value === '') {
        element.textContent = '–';
        return;
    }

    element.textContent = value;
}


function formatValue(value, decimals) {
    if (value === null || value === undefined || Number.isNaN(Number(value))) {
        return '–';
    }

    return Number(value).toFixed(decimals);
}


function formatTime(value) {
    return new Date(value).toLocaleTimeString('de-DE', {
        hour: '2-digit',
        minute: '2-digit'
    });
}


function formatDateTime(value) {
    return new Date(value).toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });
}


function formatFullDateTime(value) {
    return new Date(value).toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}


function smoothSeriesData(seriesData, windowSize = 5) {
    return seriesData.map((point, index) => {
        const start = Math.max(0, index - windowSize);
        const end = Math.min(seriesData.length, index + windowSize + 1);

        const values = seriesData
            .slice(start, end)
            .map(p => p.y)
            .filter(v => v !== null && v !== undefined);

        if (values.length === 0) {
            return point;
        }

        const average = values.reduce((sum, value) => sum + Number(value), 0) / values.length;

        return {
            x: point.x,
            y: average
        };
    });
}